import styled from 'styled-components';
import { useMyUser } from '../../hooks/useMyUser';
import { Space, UserOutlined, Avatar } from '../ui';

const SAvatar = styled(Avatar)`
  color: var(--ant-primary-color);
  background-color: transparent;
`;

const SText = styled.span`
  color: #fff;
  white-space: nowrap;
  cursor: 'default';
`;

export function UserInfo() {
  const user = useMyUser();

  return user ? (
    <Space align="center">
      <SAvatar size={28} icon={<UserOutlined />} />
      <SText>{user.userName || user.email}</SText>
    </Space>
  ) : null;
}
